/*
$("table.price_change").on("change", "input, select.bracket_type",function() {
    var name = $(this).attr('name');
    var uuid = name.replace( /\b(?:(?!\d)\w)+\b/g, '' ).replace(/\[|\]/g,"");
    if (!uuid){
        return false;
    }
    var item_row = $('tr.item_'+uuid);
    var data_row = $('tr.edit_price_change_item_form.'+uuid);
    var complete = 1;
    var bracket = price_change.brackets[uuid];
    data_row.find(':input').each(function() {
        // dont check readonly fields
        if ($(this).hasClass('readonly')){
            return true;
        }
        // dont check bracket fields that aren't part of the selected bracket
        var field_name = $(this).attr('name');
        if (field_name.includes('[qty]') || field_name.includes('[break]') || field_name.includes('[dollars]') || field_name.includes('[weight]')){
            if (!field_name.includes('['+bracket+']')){
                return true;
            }
        }
        $(this).trigger('blur');
        if ( 
            (this.required && !this.value.trim()) ||
            ($(this).hasClass('form_error'))
        ) {
    //          console_log("check input->["+$(this).attr('name')+"]");
            complete=0;
        }
    });
    //    if (($('tr.edit_price_change_item_form.'+uuid+' input.form_error').length)>0) {
    //       complete=0;
    //    }
    if (complete){
        item_row.find('span.edit_price_change_item').removeClass('incomplete').addClass('complete');      
    } else {
        item_row.find('span.edit_price_change_item').removeClass('complete').addClass('incomplete');
    }
});


$("table.price_change").on("change, blur", "input[name*='[uom_cost]']", function() {
    var rowCount = 6;
    var field_name = $(this).attr("name");
    var uom_cost = parseFloat($(this).val());
    var uuid = $(this).data('uuid');
    var item = $(this).data('item');
    var type = $(this).data('type');

    checkPrevUOMcost(uuid, rowCount, field_name, uom_cost, type);
});


$("table.price_change").on("change, blur", "input[name*='[min_price]']", function() {
    var rowCount = 6;
    var field_name = $(this).attr("name");
    var min_price = parseFloat($(this).val());
    var uuid = $(this).data('uuid');
    var item = $(this).data('item');
    var type = $(this).data('type');
    
    checkMinVal(uuid, rowCount, field_name, min_price, type);
    checkMaxMinVal(uuid, rowCount, field_name, min_price, type);
});


$("table.price_change").on("change, blur", "input[name*='[max_price]']", function() {
    var rowCount = 6;
    var field_name = $(this).attr("name");
    var max_price = parseFloat($(this).val());
    var uuid = $(this).data('uuid');
    var item = $(this).data('item');
    var type = $(this).data('type');
    
    checkMaxVal(uuid, rowCount, field_name, max_price, type);
    checkMinMaxVal(uuid, rowCount, field_name, max_price, type);
});
*/


$("table.price_change").on("change", "input[name*='[new_case_cost]'], input[name*='[new_case_cost_pr]'], input[name*='[new_case_cost_hawaii]'], input[name*='[case_pack_quantity]']", function() {
    var name = $(this).attr('name');
    var uuid = name.replace( /\b(?:(?!\d)\w)+\b/g, '' ).replace(/\[|\]/g,"");
   
    var case_cost = $("input[name='fields["+uuid+"][new_case_cost]']").val();
    var case_cost_pr = $("input[name='fields["+uuid+"][new_case_cost_pr]']").val();
    var case_cost_hawaii = $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").val();
    var case_pack_quantity = $("input[name='fields["+uuid+"][case_pack_quantity]']").val();
    
    $("input[name='fields["+uuid+"][new_unit_cost]']").val((parseFloat(case_cost)/parseFloat(case_pack_quantity)).toFixed(2));
    $("input[name='fields["+uuid+"][new_unit_cost_pr]']").val((parseFloat(case_cost_pr)/parseFloat(case_pack_quantity)).toFixed(2));
    $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").val((parseFloat(case_cost_hawaii)/parseFloat(case_pack_quantity)).toFixed(2));
    
    setUomCost(uuid);
    setChangeIndicators(uuid);
    //    imported_data_check(uuid);
});


$("table.price_change").on("change", "input[name*='[new_unit_cost]'], input[name*='[new_unit_cost_pr]'], input[name*='[new_unit_cost_hawaii]']", function() {
    var name = $(this).attr('name');
    var uuid = name.replace( /\b(?:(?!\d)\w)+\b/g, '' ).replace(/\[|\]/g,"");
  
    var unit_cost = $("input[name='fields["+uuid+"][new_unit_cost]']").val();
    var unit_cost_pr = $("input[name='fields["+uuid+"][new_unit_cost_pr]']").val();
    var unit_cost_hawaii = $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").val();
    var case_cost = $("input[name='fields["+uuid+"][new_case_cost]']").val();
    var case_cost_pr = $("input[name='fields["+uuid+"][new_case_cost_pr]']").val();
    var case_cost_hawaii = $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").val();
    var case_pack_quantity = $("input[name='fields["+uuid+"][case_pack_quantity]']").val();
        
    var calc_case_cost = (parseFloat(unit_cost)*parseFloat(case_pack_quantity)).toFixed(2);
    var calc_case_cost_pr = (parseFloat(unit_cost_pr)*parseFloat(case_pack_quantity)).toFixed(2);
    var calc_case_cost_hawaii = (parseFloat(unit_cost_hawaii)*parseFloat(case_pack_quantity)).toFixed(2);
    
    if (Math.abs(case_cost-calc_case_cost) < 0.1) {
        $("input[name='fields["+uuid+"][new_case_cost]']").val(case_cost);
    } else {
        $("input[name='fields["+uuid+"][new_case_cost]']").val(calc_case_cost);
    }
    
    if (Math.abs(case_cost_pr-calc_case_cost_pr) < 0.1) {
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").val(case_cost_pr);
    } else {
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").val(calc_case_cost_pr);
    }

    if (Math.abs(case_cost_hawaii-calc_case_cost_hawaii) < 0.1) {
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").val(case_cost_hawaii);
    } else {
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").val(calc_case_cost_hawaii);
    }
        
    setUomCost(uuid);
    setChangeIndicators(uuid);
    //    imported_data_check(uuid);
});


/**
 * 
 * @param {*} uuid 
 */
function setUomCost(uuid) {
    var case_cost = $("input[name='fields["+uuid+"][new_case_cost]']").val();
    var case_pack_quantity = $("input[name='fields["+uuid+"][case_pack_quantity]']").val();
    var shippingMethod = $('#' + uuid + '_order_unit').html();
    var uom_cost = 0;
    
    if (shippingMethod != '') {        
        switch (shippingMethod) {
            case "CS":
                if (case_cost != '') {
                    uom_cost = parseFloat(case_cost);
                }
                break;
                
            case "DZ":
                if (case_cost != '' && case_pack_quantity != '') {
                    uom_cost = (parseFloat(case_cost)/parseFloat(case_pack_quantity))*12;
                }
                break;
            
    //          case "PK":
    //             if (case_cost != '' && case_pack_quantity != '' && inner_pack_quantity != '') {
    //                uom_cost = (parseFloat(case_cost)/parseFloat(case_pack_quantity)) * inner_pack_quantity;
    //             }
    //             break;
                
            case "EA":
                if (case_cost != '' && case_pack_quantity != '') {
                    uom_cost = (parseFloat(case_cost)/parseFloat(case_pack_quantity));
                }
                break;
                
    //          case "DL":
    //             if (display_cost_override != '') {
    //                uom_cost = parseFloat(display_cost_override);
    //             }
    //             else {
    //                uom_cost = parseFloat(display_cost);
    //             }
    //             break;
        }
        
        $("#bracket_pricing_dollars_"+uuid+" .uom").empty();
        $("#bracket_pricing_dollars_"+uuid+" .uom").append(shippingMethod);
        $("#bracket_pricing_qty_"+uuid+" .uom").empty();
        $("#bracket_pricing_qty_"+uuid+" .uom").append(shippingMethod);
        $("#bracket_pricing_weight_"+uuid+" .uom").empty();
        $("#bracket_pricing_weight_"+uuid+" .uom").append(shippingMethod);
        $("#bracket_pricing_break_"+uuid+" .uom").empty();
        $("#bracket_pricing_break_"+uuid+" .uom").append(shippingMethod);
        
        $("input[name='fields["+uuid+"][bracket_break_pricing][dollars][1][uom_cost]']").val(uom_cost.toFixed(2));
        $("input[name='fields["+uuid+"][bracket_break_pricing][dollars][1][uom_cost]']").attr("readonly",true).parent("td").addClass("readonly");
        
        $("input[name='fields["+uuid+"][bracket_break_pricing][qty][1][uom_cost]']").val(uom_cost.toFixed(2));
        $("input[name='fields["+uuid+"][bracket_break_pricing][qty][1][uom_cost]']").attr("readonly",true).parent("td").addClass("readonly");
        
        $("input[name='fields["+uuid+"][bracket_break_pricing][weight][1][uom_cost]']").val(uom_cost.toFixed(2));
        $("input[name='fields["+uuid+"][bracket_break_pricing][weight][1][uom_cost]']").attr("readonly",true).parent("td").addClass("readonly");
        
        $("input[name='fields["+uuid+"][bracket_break_pricing][break][1][uom_cost]']").val(uom_cost.toFixed(2));
        $("input[name='fields["+uuid+"][bracket_break_pricing][break][1][uom_cost]']").attr("readonly",true).parent("td").addClass("readonly");
    }
}


/**
 * 
 * @param {*} uuid 
 */
function setChangeIndicators(uuid) {
    var old_case_cost = ($("input[name='fields["+uuid+"][old_case_cost]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_case_cost]']").val()) : 0);
    var case_cost = parseFloat($("input[name='fields["+uuid+"][new_case_cost]']").val());
        
    if (case_cost < old_case_cost) {
        $("input[name='fields["+uuid+"][new_case_cost]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_case_cost.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost]']").flashClass('red');
    } else if (case_cost > old_case_cost) {
        $("input[name='fields["+uuid+"][new_case_cost]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_case_cost.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_case_cost]']").parent().find('.trend').removeClass("decreasing increasing").html(old_case_cost.toFixed(2));
    }
    

    var old_case_cost_pr = ($("input[name='fields["+uuid+"][old_case_cost_pr]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_case_cost_pr]']").val()) : 0);
    var case_cost_pr = parseFloat($("input[name='fields["+uuid+"][new_case_cost_pr]']").val());
   
    if (case_cost_pr < old_case_cost_pr) {
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_case_cost_pr.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").flashClass('red');
    } else if (case_cost_pr > old_case_cost_pr) {
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_case_cost_pr.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_case_cost_pr]']").parent().find('.trend').removeClass("decreasing increasing").html(old_case_cost_pr.toFixed(2));
    }
    

    var old_case_cost_hawaii = ($("input[name='fields["+uuid+"][old_case_cost_hawaii]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_case_cost_hawaii]']").val()) : 0);
    var case_cost_hawaii = parseFloat($("input[name='fields["+uuid+"][new_case_cost_hawaii]']").val());
    
    if (case_cost_hawaii < old_case_cost_hawaii) {
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_case_cost_hawaii.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").flashClass('red');
    } else if (case_cost_hawaii > old_case_cost_hawaii) {
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_case_cost_hawaii.toFixed(2));
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_case_cost_hawaii]']").parent().find('.trend').removeClass("decreasing increasing").html(old_case_cost_hawaii.toFixed(2));
    }


    var old_unit_cost = ($("input[name='fields["+uuid+"][old_unit_cost]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_unit_cost]']").val()) : 0);
    var unit_cost = parseFloat($("input[name='fields["+uuid+"][new_unit_cost]']").val());

    if (unit_cost < old_unit_cost) {
        $("input[name='fields["+uuid+"][new_unit_cost]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_unit_cost.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost]']").flashClass('red');
    } else if (unit_cost > old_unit_cost) {
        $("input[name='fields["+uuid+"][new_unit_cost]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_unit_cost.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_unit_cost]']").parent().find('.trend').removeClass("decreasing increasing").html(old_unit_cost.toFixed(2));
    }

    
    var old_unit_cost_pr = ($("input[name='fields["+uuid+"][old_unit_cost_pr]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_unit_cost_pr]']").val()) : 0);
    var unit_cost_pr = parseFloat($("input[name='fields["+uuid+"][new_unit_cost_pr]']").val());

    if (unit_cost_pr < old_unit_cost_pr) {
        $("input[name='fields["+uuid+"][new_unit_cost_pr]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_unit_cost_pr.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost_pr]']").flashClass('red');
    } else if (unit_cost_pr > old_unit_cost_pr) {
        $("input[name='fields["+uuid+"][new_unit_cost_pr]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_unit_cost_pr.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost_pr]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_unit_cost_pr]']").parent().find('.trend').removeClass("decreasing increasing").html(old_unit_cost_pr.toFixed(2));
    }


    var old_unit_cost_hawaii = ($("input[name='fields["+uuid+"][old_unit_cost_hawaii]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_unit_cost_hawaii]']").val()) : 0);
    var unit_cost_hawaii = parseFloat($("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").val());
    
    if (unit_cost_hawaii < old_unit_cost_hawaii) {
        $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_unit_cost_hawaii.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").flashClass('red');
    } else if (unit_cost_hawaii > old_unit_cost_hawaii) {
        $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_unit_cost_hawaii.toFixed(2));
        $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][new_unit_cost_hawaii]']").parent().find('.trend').removeClass("decreasing increasing").html(old_unit_cost_hawaii.toFixed(2));
    }


    var old_case_pack_quantity = ($("input[name='fields["+uuid+"][old_case_pack_qty]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_case_pack_qty]']").val()) : 0);
    var case_pack_quantity = parseFloat($("input[name='fields["+uuid+"][case_pack_quantity]']").val());

    if (case_pack_quantity < old_case_pack_quantity) {
        $("input[name='fields["+uuid+"][case_pack_quantity]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_case_pack_quantity);
        $("input[name='fields["+uuid+"][case_pack_quantity]']").flashClass('red');
    } else if (case_pack_quantity > old_case_pack_quantity) {
        $("input[name='fields["+uuid+"][case_pack_quantity]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_case_pack_quantity);
        $("input[name='fields["+uuid+"][case_pack_quantity]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][case_pack_quantity]']").parent().find('.trend').removeClass("decreasing increasing").html(old_case_pack_quantity);
    }


    var old_list_price = ($("input[name='fields["+uuid+"][old_list_price]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_list_price]']").val()) : 0);
    var list_price = parseFloat($("input[name='fields["+uuid+"][list_price]']").val());

    if (list_price < old_list_price) {
        $("input[name='fields["+uuid+"][list_price]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_list_price.toFixed(2));
        $("input[name='fields["+uuid+"][list_price]']").flashClass('red');
    } else if (list_price > old_list_price) {
        $("input[name='fields["+uuid+"][list_price]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_list_price.toFixed(2));
        $("input[name='fields["+uuid+"][list_price]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][list_price]']").parent().find('.trend').removeClass("decreasing increasing").html(old_list_price.toFixed(2));
    }


    var old_net_price = ($("input[name='fields["+uuid+"][old_net_price]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_net_price]']").val()) : 0);
    var net_price = parseFloat($("input[name='fields["+uuid+"][net_price]']").val());

    if (net_price < old_net_price) {
        $("input[name='fields["+uuid+"][net_price]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_net_price.toFixed(2));
        $("input[name='fields["+uuid+"][net_price]']").flashClass('red');
    } else if (net_price > old_net_price) {
        $("input[name='fields["+uuid+"][net_price]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_net_price.toFixed(2));
        $("input[name='fields["+uuid+"][net_price]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][net_price]']").parent().find('.trend').removeClass("decreasing increasing").html(old_net_price.toFixed(2));
    }


    var old_srp = ($("input[name='fields["+uuid+"][old_srp]']").val() ? parseFloat($("input[name='fields["+uuid+"][old_srp]']").val()) : 0);
    var srp = parseFloat($("input[name='fields["+uuid+"][srp]']").val());

    if (srp < old_srp) {
        $("input[name='fields["+uuid+"][srp]']").parent().find('.trend').removeClass("increasing").addClass("decreasing").html(old_srp);
        $("input[name='fields["+uuid+"][srp]']").flashClass('red');
    } else if (srp > old_srp) {
        $("input[name='fields["+uuid+"][srp]']").parent().find('.trend').removeClass("decreasing").addClass("increasing").html(old_srp);
        $("input[name='fields["+uuid+"][srp]']").flashClass('green');
    } else {
        $("input[name='fields["+uuid+"][srp]']").parent().find('.trend').removeClass("decreasing increasing").html(old_srp);
    }
}